import { buildProdEnvironment } from './environment.builder';
import {Environments} from "../app/layout/model/interfaces/environments.interface";

export const environment = buildProdEnvironment();

// typescript constant naming convention - UPPERCASE
export const ENVIRONMENT: Environments = { ... environment}